import { inject, Injectable } from '@angular/core';
import { AsyncApiService } from '@spike/core';
import { ConfirmationDialogService } from '../../shared/services/confirmation-dialog.service';
import { EntityApiEnum } from 'src/app/config/entity-api.enum';
import { EquipmentRequest } from '../../orders/models/equipment-request.model';

@Injectable({ providedIn: 'root' })
export class WorkflowApiService {
    private readonly asyncApiService = inject(AsyncApiService);
    private readonly confirmationDialogService = inject(ConfirmationDialogService);

    public async execute(action: string, positionId: number): Promise<boolean> {
        return new Promise((resolve) => {
            this.confirmationDialogService.show('Sei sicuro di voler cambiare lo stato?', async () => {
                try {
                    const result = await this.executeConfirmed(action, positionId);
                    resolve(result);
                } catch (error) {
                    resolve(false); // O gestisci l'errore
                }
            });
        });
    }

    public async executeConfirmed(action: string, positionId: number): Promise<boolean> {
        let endpoint = '';

        switch (action) {
            case 'INIZIA_PREVENTIVO':         
                endpoint = 'order/inizia-preventivo'; 
                break;
            case 'ARCHIVIA':         
                endpoint = 'order/archivia-ordine'; 
                break;
            case 'RIAPRI':
                endpoint = 'order/riapri-ordine';
                break;
            case 'COMPLETA_PREVENTIVO':         
                endpoint = 'posizione/completa-preventivo'; 
                break;
            case 'INVIA_PREVENTIVO':            
                endpoint = 'posizione/invia-preventivo'; 
                break;
            case 'ACCETTA_PREVENTIVO':          
                endpoint = 'posizione/accetta-preventivo'; 
                break;
            case 'COMPLETA_PROGETTAZIONE':      
                endpoint = 'posizione/completa-progettazione'; 
                break;
            case 'RIFIUTA_PREVENTIVO':
                endpoint = 'posizione/rifiuta-preventivo'; 
                break;
            case 'COMPLETA_RICHIESTA_MATERIALE':
                endpoint = 'posizione/completa-richiesta-materiale'; 
                break;
            case 'INIZIA_LAVORAZIONE':
                endpoint = 'posizione/inizia-lavorazione'; 
                break;
            case 'COMPLETA_LAVORAZIONE':
                endpoint = 'posizione/completa-lavorazione'; 
                break;  
            case 'COMPLETA_CONSUNTIVO':
                endpoint = 'posizione/completa-consuntivo'; 
                break;
            case 'SPEDITO':
                endpoint = 'posizione/spedito'; 
                break;
            case 'CONSEGNATO':
                endpoint = 'posizione/consegnato'; 
                break;
            case 'BACK':    
                endpoint = 'posizione/back';
                break;
            default: return false;
        }
        
        return await this.asyncApiService.call<boolean>(EntityApiEnum.WORKFLOW, endpoint,{ id: positionId });
    }

    public async createEquipmentRequest(equipmentRequest: EquipmentRequest): Promise<boolean> {
        return await this.asyncApiService.call<boolean>(EntityApiEnum.WORKFLOW, 'posizione/crea-richiesta-materiale',equipmentRequest);
    }
    public async updateEquipmentRequest(equipmentRequest: EquipmentRequest): Promise<boolean> {
        return await this.asyncApiService.call<boolean>(EntityApiEnum.WORKFLOW, 'posizione/aggiorna-richiesta-materiale',equipmentRequest);
    }
    public async deleteEquipmentRequest(equipmentRequest: EquipmentRequest): Promise<boolean> {
        return await this.asyncApiService.call<boolean>(EntityApiEnum.WORKFLOW, 'posizione/cancella-richiesta-materiale',equipmentRequest);
    }
}